import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-end;
  width: 100%;
`;

export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #7b7b7b;
  margin-bottom: 6px;
  display: block;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  flex: 1;
  position: relative;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;

export const ActionButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: #f4f4f4;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  color: #666;
  transition: all 0.2s;

  &:hover {
    background: #e0e0e0;
    border-color: #bbb;
  }

  &:active {
    background: #d0d0d0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MunicipioList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 10px;
`;

export const MunicipioItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  color: #7b7b7b;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: #f27160;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
`;

export const EmptyState = styled.div`
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
  font-style: italic;
`;

export const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const AutocompleteItem = styled.div`
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  color: #7b7b7b;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }

  &:first-child {
    border-top: 1px solid #f0f0f0;
  }
`;

export const UfPercursoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  padding: 20px;
`;

export const UfInputField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex: 1;
  position: relative;
  
  input {
    background: #f4f4f4;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 8px 12px;
    width: 100%;
  }
`;

export const UfListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 10px;
`;

export const UfListItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  color: #7b7b7b;
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
  gap: 15px;
  width: 100%;
`;

export const ItemsPerPageSelect = styled.select`
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  color: #7b7b7b;
  background: white;
  cursor: pointer;
  margin-left: auto;
  margin-right: 10px;

  &:focus {
    outline: none;
    border-color: #122d58;
  }
`;

export const ItemsPerPageLabel = styled.span`
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  color: #666;
  margin-right: 5px;
`;

export const PaginationInfo = styled.span`
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  color: #666;
  margin-left: auto;
`;

